import { render, staticRenderFns } from "./UserFacilitiesWithUnsignedNotes.vue?vue&type=template&id=bda44a9c&"
import script from "./UserFacilitiesWithUnsignedNotes.vue?vue&type=script&lang=js&"
export * from "./UserFacilitiesWithUnsignedNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports